import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, FlameIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { HERO_IMAGE } from '../data/content';
export function Hero() {
  return <header className="w-full" data-id="element-91" data-mp="9lv1krql6hwd">
      <div className="mx-auto max-w-5xl px-6 pb-0 pt-14 text-center sm:pt-20" data-id="element-92" data-mp="9l33995lu62e">
        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="mb-6 inline-flex items-center gap-2 rounded-full border border-salvia/70 bg-salvia/15 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-bosque" data-id="element-93" data-mp="4n1j0kwg00pc">
          Mindfulness para hockey
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.05
      }} className="font-display text-4xl font-semibold leading-[1.05] tracking-tight text-tinta sm:text-6xl lg:text-7xl" data-id="element-94" data-mp="ncq0pcba9kmr">
          Jugá con una mente
          <br className="hidden sm:block" data-id="element-95" data-mp="3j7zgtn69y0is" />{' '}
          <span className="text-bosque" data-id="element-96" data-mp="3j9ah3d0igq55">tan fuerte como tu hockey</span>
        </motion.h1>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.7,
      delay: 0.1
    }} className="-my-6 w-full sm:-my-14" data-id="element-97" data-mp="3o6u534n0ghaa">
        <img src={HERO_IMAGE} alt="Libro Mindfulness para Hockey con sus bonos: fichas de respiración, escaneo corporal, rutina pre partido y plan semanal mental" className="mx-auto block h-auto w-full max-w-[1280px] object-contain mix-blend-multiply" data-id="element-98" data-mp="3e7uxlpdzerov" />
      </motion.div>

      <div className="mx-auto max-w-3xl px-6 pb-20 pt-0 text-center sm:pb-28" data-id="element-99" data-mp="2qlod43ndfjhr">
        <p className="text-lg leading-relaxed text-tinta/70 sm:text-xl" data-id="element-100" data-mp="2vjpvsngvxgsp">
          El sistema de entrenamiento mental que te ayuda a competir con calma,
          controlar la presión y disfrutar del hockey.
        </p>

        <div className="mt-8 flex items-center justify-center gap-3" data-id="element-101" data-mp="2lmv0sejtlyj6">
          <span className="flex" aria-hidden="true" data-id="element-102" data-mp="s2tffr2zujsd">
            {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-5 w-5 fill-oliva text-oliva" strokeWidth={1.5} data-id="element-103" data-mp="nb1jt24zdnvd" />)}
          </span>
          <span className="text-sm font-semibold text-tinta" data-id="element-104" data-mp="id9soac5u5s8">
            4.9/5 estrellas
          </span>
        </div>

        <div className="mt-10" data-id="element-105" data-mp="deq8aed7t21z">
          <CtaButton className="w-full sm:w-auto" data-id="element-106" data-mp="1b0vwnjpavcfm" />
          <p className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-oliva" data-id="element-107" data-mp="1azkv7qjbugro">
            <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-108" data-mp="162uc0uc87521" />
            Oferta especial por tiempo limitado
          </p>
        </div>
      </div>
    </header>;
}